import apiClient from './apiClient';

export const fetchFormData = async () => {
  const response = await apiClient.get('/validation-rules/');
  return response.data;
};

export const fetchFormDropdownData = async () => {
  const response = await apiClient.get('/constants-data/');
  // console.log(response)
  return response.data;
};